export default __webpack_public_path__ + "static/banner-pl-loan-insurance-9c318bdb05bff2419349365c35462d6f.jpg";